import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import BlockList from 'components/application/BlockList';

export default function PersonnelSidePanelTeamsTab({ teams }) {
  const { t: i18nTTeams } = useTranslation('common', {
    keyPrefix: 'teams',
  });

  return teams.length > 0 ?
      <BlockList
        collection={teams}
        onItemDisplay={(team) => (
          <div className='block-list__item--flex-container'>
            <span className='truncated-text-container truncated-text-container--width-auto'>
              {team.attributes.name}
            </span>
          </div>
        )}
      />
    : <div className='tw-px-5 tw-py-6 tw-text-grey-400'>
        {i18nTTeams('notMemberOfAnyTeams')}
      </div>;
}

PersonnelSidePanelTeamsTab.propTypes = {
  teams: PropTypes.array.isRequired,
};
